module.exports = __webpack_public_path__ + "static/media/flag.edf0fc09.svg";